import api from '../api';

const LOGIN_URL = '/authentication/login';
const LOGIN_AD_URL = '/authentication/login/ad';

export async function login(data) {
  return api.post(LOGIN_URL, JSON.stringify(data), {
    headers: { 'Content-Type': 'application/json' },
  });
}

export function extractAdminFromToken(token) {
  const data = token.split('.')[1];
  const jsonString = window.atob(data);
  return JSON.parse(jsonString);
}

export async function loginAzureAd(data) {
  return api.post(LOGIN_AD_URL, JSON.stringify(data), {
    headers: { 'Content-Type': 'application/json' },
  });
}
